import { SingleType } from "./File"

export interface iAudioVersions {
  original?: SingleType
}

export enum eAudioVersions {
  original = "original",
}
